var map = {
	"./": "2a05",
	"./confirmRegistrationRequest": "72ca",
	"./confirmRegistrationRequest.js": "72ca",
	"./createPartner": "8be2",
	"./createPartner.js": "8be2",
	"./getPartnerCredentials": "0074",
	"./getPartnerCredentials.js": "0074",
	"./getRegistrationRequestDetails": "d162",
	"./getRegistrationRequestDetails.js": "d162",
	"./getRegistrationRequests": "23c4",
	"./getRegistrationRequests.js": "23c4",
	"./getResellerDetails": "a05d",
	"./getResellerDetails.js": "a05d",
	"./getResellersList": "1162",
	"./getResellersList.js": "1162",
	"./getResellersShortList": "0035",
	"./getResellersShortList.js": "0035",
	"./getUniqueCodeList": "09d3",
	"./getUniqueCodeList.js": "09d3",
	"./index": "2a05",
	"./index.js": "2a05",
	"./refreshPartnersList": "4e70",
	"./refreshPartnersList.js": "4e70",
	"./refreshRegistrationRequests": "4077",
	"./refreshRegistrationRequests.js": "4077",
	"./refreshResellersList": "ab12",
	"./refreshResellersList.js": "ab12",
	"./rejectRegistrationRequest": "c372",
	"./rejectRegistrationRequest.js": "c372"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ca3";